import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { useAuth } from "contexts/AuthContext";
import { RootState } from "redux/reducers";
import { sendContactUsMessage } from "redux/actions/admin";
import { clearErrors } from "redux/actions/errors";

import closeIcon from "assets/icons/close-black.svg";

import { BUY_REPORT } from "data/email";
import TextAreaInput from "./TextAreaInput";
import StandardButton from "components/Common/buttons/StandardButton";

type BuyReportProps = {
  setToggleModal: Function;
  report_name: string;
  report_year: string;
  report_id: number;
};

export const BuyReport: React.FC<BuyReportProps> = ({
  setToggleModal,
  report_name,
  report_year,
  report_id,
}) => {
  const dispatch = useDispatch();
  const { currentUser } = useAuth();
  const errors = useSelector((state: RootState) => state.errors);
  const [message, setMessage] = useState<string>("");

  let subject: string;

  useEffect(() => {
    return () => {
      dispatch(clearErrors());
    };
  }, [dispatch]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearErrors());

    subject = BUY_REPORT;

    const reportInfo = `${report_name} ${report_year} ID: ${report_id}`;

    const userMessage = {
      name: currentUser.name,
      email: currentUser.email,
      phone: currentUser.phone || "n/a",
      title: currentUser.title || "n/a",
      company: currentUser.company,
      category: "",
      message,
      subject,
      other: reportInfo,
    };

    dispatch(sendContactUsMessage(userMessage, setToggleModal));
  };

  return (
    <Container onSubmit={handleSubmit}>
      <Header>
        <div>Requesting to Buy</div>
        <button
          onClick={() => {
            setToggleModal(false);
          }}
        >
          <img src={closeIcon} alt="close icon" />
        </button>
      </Header>
      <Report>
        {report_name} - {report_year}
      </Report>
      <Note>
        <TextAreaInput
          name="message"
          placeholder="Add a note for our sales team (optional)"
          onChange={(e) => setMessage(e.target.value)}
          value={message}
          error={errors.message}
        />
      </Note>
      <ButtonContainer>
        <StandardButton type="submit" size="md">
          Send request
        </StandardButton>
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.form`
  padding: 2rem;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.5em;
  margin-bottom: 1em;
`;

const Report = styled.div`
  margin: 2rem;
`;

const Note = styled.div`
  margin: 0 2rem 2rem;
  max-width: 45rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export default BuyReport;
